import { render, staticRenderFns } from "./RawMaterialConsumptionMin.vue?vue&type=template&id=70503117"
import script from "./RawMaterialConsumptionMin.vue?vue&type=script&lang=js"
export * from "./RawMaterialConsumptionMin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports